import { ENV_VERSION } from 'configs/vars';
import React, { createContext, useCallback, useState } from 'react';
import { DebuggableResponse } from 'typings/dto/_debug';

export const DebugContext = createContext<{ debugMode: boolean; handleDebugResponse: <T>(res: DebuggableResponse<T>) => T }>({
  debugMode: false,
  handleDebugResponse: (res) => res,
});

/** Должен использоваться исключительно для целей отладки приложения */
export function DebugContextProvider({ children }: { children: React.ReactNode }) {
  const [debugMode] = useState(() => {
    if (localStorage.getItem('debugMode')) {
      return JSON.parse(localStorage.getItem('debugMode') as string);
    }
    const debugMode = ENV_VERSION === 'development';
    localStorage.setItem('debugMode', JSON.stringify(debugMode));
    return debugMode;
  });

  const handleDebugResponse = useCallback(<T,>(res: DebuggableResponse<T>) => {
    if (debugMode) {
      console.debug(res.debugLog);
    }
    return res;
  }, []);

  return <DebugContext.Provider value={{ debugMode, handleDebugResponse }}>{children}</DebugContext.Provider>;
}
